/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint new-cap: 0 */
import * as Blockly from 'blockly';
import './modalField.scss';

/**
 * Base de los campos que abren un editor propio en un modal. Cada subclase
 * define name_ (clases CSS e ids), blockWidth_/blockHeight_, renderBlockContent_(),
 * renderModalContent_() y, opcional, addCustomModalEvents().
 */
export class ModalField extends Blockly.Field {
  name_ = 'Modal';

  blockWidth_ = 410;

  blockHeight_ = 43;

  boundEvents_ = [];

  contentDiv_ = null;

  // Los ids de Blockly traen caracteres que no son validos en un id de DOM.
  normalizeBlocklyIds_() {
    return this.getSourceBlock().id.replace(/[^a-zA-Z0-9]+/g, '');
  }

  // Se usa la referencia de initView y no getElementById: dos bloques (ej. flyout
  // y workspace) pueden normalizar al mismo id de DOM y se repintaría la copia equivocada.
  blockContentDiv() {
    return this.contentDiv_
      || document.getElementById(`${this.name_}-${this.normalizeBlocklyIds_()}`);
  }

  // La miniatura es HTML propio, no la repinta el render de Blockly: sin esto un cambio
  // que llega por setValue() desde afuera (evento remoto, undo/redo) deja la miniatura vieja.
  doValueUpdate_(newValue) {
    super.doValueUpdate_(newValue);
    if (this.contentDiv_) {
      this.contentDiv_.innerHTML = this.renderBlockContent_();
    }
  }

  // Para campos que persisten con setValue(), que ya dispara el evento de
  // cambio: llamar además a updateWorkspace() lo duplicaría.
  paintBlockContent() {
    const divContent = this.blockContentDiv();
    if (divContent) {
      divContent.innerHTML = this.renderBlockContent_();
    }
  }

  // Para los campos que mutan this.value_ directamente y necesitan avisar.
  refreshBlockContent() {
    const divContent = this.blockContentDiv();
    if (divContent) {
      divContent.innerHTML = this.renderBlockContent_();
      this.updateWorkspace();
    }
  }

  addModalEvents() {
    if (this.addCustomModalEvents) {
      this.addCustomModalEvents();
    }
  }

  initView() {
    const fieldGroup = this.getParentInput().fieldRow[0].fieldGroup_;
    if (fieldGroup) {
      const divContent = document.createElement('div');
      divContent.id = `${this.name_}-${this.normalizeBlocklyIds_()}`;
      divContent.className = `${this.name_}BlockContent`;
      divContent.innerHTML = this.renderBlockContent_();
      this.contentDiv_ = divContent;

      const foreignObject = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
      foreignObject.setAttribute('id', `foreign-${this.name_}-${this.normalizeBlocklyIds_()}`);
      foreignObject.setAttribute('width', this.blockWidth_);
      foreignObject.setAttribute('height', this.blockHeight_);
      // Solo Matrix8x16Modal define junior_; ver matrix8x16Modal.scss por el overflow visible.
      if (this.junior_) {
        foreignObject.classList.add('matrix-foreign-junior');
      }
      foreignObject.appendChild(divContent);

      fieldGroup.appendChild(foreignObject);
      Blockly.browserEvents.conditionalBind(
        foreignObject,
        'click',
        this,
        (_) => this.showWidget_(),
      );

      this.updateSize_();
    }
  }

  // WidgetDiv.show() siempre registra en el FocusManager un handler que cierra
  // el widget al "perder el foco", y eso pasa con solo cambiar de pestaña. v13
  // no permite evitarlo (ignora manageEphemeralFocus), así que se anula el
  // registro solo mientras corre show(); el cierre explícito no depende de él.
  showWidget_() {
    const focusManager = Blockly.getFocusManager();
    const originalRegister = focusManager.registerPopoverFocusLossHandler.bind(focusManager);
    focusManager.registerPopoverFocusLossHandler = () => {};
    try {
      Blockly.WidgetDiv.show(this, false, this.widgetDispose_);
    } finally {
      focusManager.registerPopoverFocusLossHandler = originalRegister;
    }
  }

  updateSize_() {
    this.size_.width = this.blockWidth_;
    this.size_.height = this.blockHeight_;
  }

  updateWorkspace() {
    Blockly.Events.fire(
      new (Blockly.Events.get(Blockly.Events.BLOCK_CHANGE))(
        this.getSourceBlock(),
        'field',
        this.name || null,
        this.initialValue,
        this.getValue(),
      ),
    );
  }

  closeModal() {
    const modalElement = document.querySelector(`.${this.name_}Modal`);
    if (modalElement) {
      modalElement.classList.remove('initial-animation');
      modalElement.classList.add('final-animation');
    }
    setTimeout(() => {
      this.disposeEvents();
      Blockly.WidgetDiv.hide();
    }, 200);
  }

  showEditor_() {
    const backDrop = document.createElement('div');
    backDrop.className = `${this.name_}BackDrop`;

    const div = document.createElement('div');
    div.innerHTML = this.renderModalContent_();
    div.className = `${this.name_}Modal`;
    div.classList.add('initial-animation');

    Blockly.WidgetDiv.createDom();
    const widgetDiv = Blockly.WidgetDiv.getDiv();
    if (widgetDiv) {
      widgetDiv.style.top = 0;
      backDrop.appendChild(div);
      widgetDiv.appendChild(backDrop);
    }
    this.addModalEvents();

    this.addEvent_(backDrop, 'click', this, (event) => {
      if (event.target === backDrop) {
        this.updateWorkspace();
        this.closeModal();
      }
    });
  }

  disposeEvents() {
    this.boundEvents_.map((event) => {
      Blockly.browserEvents.unbind(event);
      return false;
    });
    this.boundEvents_ = [];
  }

  widgetDispose_() {
    const widgetDiv = Blockly.WidgetDiv.getDiv();
    if (widgetDiv) {
      while (widgetDiv.firstChild) {
        widgetDiv.removeChild(widgetDiv.firstChild);
      }
    }
  }

  addEvent_(node, name, thisObject, func) {
    const event = Blockly.browserEvents.conditionalBind(
      node,
      name,
      thisObject,
      func,
    );
    this.boundEvents_.push(event);
  }
}
